import {PAGE_HOTELS, PAGE_OFFERS} from '@/consts';
import {useLocalSplit} from '@/modules/common/hooks';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';

export const useNewsletterBannerSplit = () => {
  const split = useLocalSplit(
    'FSE-2710_promotion_banner_for_newsletter_subscription'
  );
  const currentPage = useCurrentPage();

  // @see https://invia.atlassian.net/browse/FFP-4173
  // enabled until 2024-02-12 (exclusive)
  const anniversaryBannerEnabled = Date.now() < new Date(2024, 1, 12).valueOf();

  const enabled =
    split.ready &&
    split.treatment === 'on' &&
    (currentPage === PAGE_HOTELS ||
      (currentPage === PAGE_OFFERS && anniversaryBannerEnabled));

  const treatment = anniversaryBannerEnabled ? 'anniversary' : 'regular';

  return {
    ready: split.ready,
    enabled,
    treatment,
  };
};
